<template>
  <div class="group-setup">
    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>

    <v-form>
      <v-card class="my-card">
        <HeaderDividerBlock headerText="Customer Details"></HeaderDividerBlock>
        <v-container class="pa-4">
          <!-- Reduced padding from pa-6 to pa-4 -->
          <v-row>
            <v-col cols="6" md="6">
              <v-col class="pa-0 ma-0">
                <p class="text-title">Customer / Company Name*</p>
              </v-col>
              <v-text-field
                outlined
                dense
                v-model="form.company_name"
                required
                placeholder="Enter Customer / Company Name*"
                clearable
              ></v-text-field>
            </v-col>
            <v-col cols="6" md="6">
              <v-col class="pa-0 ma-0">
                <p class="text-title">Customer Category*</p>
              </v-col>
              <v-autocomplete
                v-model="form.customer_category_id"
                :items="customerCategoryOptions"
                item-text="name"
                item-value="id"
                dense
                outlined
                placeholder="Select Customer Category*"
                clearable
                required
                @change="onCategoryChange"
              />
            </v-col>
            <v-col cols="6" md="6">
              <v-col class="pa-0 ma-0">
                <p class="text-title">VAT Number</p>
              </v-col>
              <v-text-field
                outlined
                dense
                v-model="form.vat_number"
                placeholder="Enter VAT Number"
                clearable
              ></v-text-field>
            </v-col>
            <v-col cols="6" md="6">
              <v-col class="pa-0 ma-0">
                <p class="text-title">Tax Number</p>
              </v-col>
              <v-text-field
                outlined
                dense
                v-model="form.tax_number"
                placeholder="Enter Tax Number"
                clearable
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="12">
              <v-label class="mt-2"
                >Profile Image / Logo (200px X 200px)</v-label
              >
              <FileUpload @changeFile="changeFile" :type="'image/*'" />
              <v-col class="mt-2">
                <ImageBox :imageUrl="imageUrl" />
              </v-col>
            </v-col>
          </v-row>
        </v-container>
      </v-card>

      <v-card>
        <HeaderDividerBlock headerText="Contact Person"></HeaderDividerBlock>
        <v-container class="pa-6">
          <v-row>
            <v-col cols="6" md="4">
              <v-col class="pa-0 ma-0">
                <p class="text-title">Title</p>
              </v-col>
              <v-autocomplete
                v-model="form.title"
                :items="titleList"
                dense
                outlined
                placeholder="Select Title"
                clearable
              ></v-autocomplete>
            </v-col>
            <v-col cols="6" md="4">
              <v-col class="pa-0 ma-0">
                <p class="text-title">First Name*</p>
              </v-col>
              <v-text-field
                outlined
                dense
                v-model="form.first_name"
                required
                placeholder="Enter First Name*"
              ></v-text-field>
            </v-col>
            <v-col cols="6" md="4">
              <v-col class="pa-0 ma-0">
                <p class="text-title">Last Name*</p>
              </v-col>
              <v-text-field
                outlined
                dense
                v-model="form.last_name"
                required
                placeholder="Enter Last Name*"
              ></v-text-field>
            </v-col>
            <v-col cols="6" md="4">
              <v-col class="pa-0 ma-0">
                <p class="text-title">Email</p>
              </v-col>
              <v-text-field
                outlined
                dense
                v-model="form.email"
                placeholder="Enter Email"
                :rules="emailRules"
              ></v-text-field>
            </v-col>
            <v-col cols="6" md="4">
              <v-col class="pa-0 ma-0">
                <p class="text-title">Phone</p>
              </v-col>
              <v-text-field
                outlined
                dense
                v-model="form.phone"
                placeholder="Enter Phone"
              ></v-text-field>
            </v-col>
            <v-col cols="6" md="4">
              <v-col class="pa-0 ma-0">
                <p class="text-title">Mobile</p>
              </v-col>
              <v-text-field
                outlined
                dense
                v-model="form.mobile"
                placeholder="Enter Mobile"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
      <br />
      <v-card>
        <HeaderDividerBlock headerText="Address Details"></HeaderDividerBlock>
        <v-container class="pa-6">
          <v-row>
            <v-col cols="6" md="4">
              <v-col class="pa-0 ma-0">
                <p class="text-title">Address 1</p>
              </v-col>
              <v-text-field
                outlined
                dense
                v-model="form.address1"
                placeholder="Enter Address 1"
              ></v-text-field>
            </v-col>
            <v-col cols="6" md="4">
              <v-col class="pa-0 ma-0">
                <p class="text-title">Address 2</p>
              </v-col>
              <v-text-field
                outlined
                dense
                v-model="form.address2"
                placeholder="Enter Address 2"
              ></v-text-field>
            </v-col>
            <v-col cols="6" md="4">
              <v-col class="pa-0 ma-0">
                <p class="text-title">City</p>
              </v-col>
              <v-text-field
                outlined
                dense
                v-model="form.city"
                placeholder="Enter City"
              ></v-text-field>
            </v-col>
            <v-col cols="6" md="4">
              <v-col class="pa-0 ma-0">
                <p class="text-title">State</p>
              </v-col>
              <v-autocomplete
                v-model="form.state_id"
                :items="states"
                placeholder="Select State"
                item-text="name"
                item-value="id"
                dense
                outlined
                clearable
                :disabled="!form.country_id"
              ></v-autocomplete>
            </v-col>
            <v-col cols="6" md="4">
              <v-col class="pa-0 ma-0">
                <p class="text-title">Postal Code</p>
              </v-col>
              <v-text-field
                outlined
                dense
                v-model="form.postal_code"
                placeholder="Enter Postal Code"
              ></v-text-field>
            </v-col>
            <v-col cols="6" md="4">
              <v-col class="pa-0 ma-0">
                <p class="text-title">Country</p>
              </v-col>
              <v-autocomplete
                v-model="form.country_id"
                :items="countries"
                placeholder="Select Country"
                item-text="country_name"
                item-value="id"
                dense
                outlined
                clearable
                @change="onCountryChange"
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-container>
      </v-card>

      <v-card-actions class="mt-10">
        <v-row>
          <v-col cols="12" md="10" xs="6"></v-col>
          <v-col cols="12" md="2" xs="6">
            <v-btn
              large
              color="#00B3FF"
              dark
              depressed
              block
              @click="submit"
              v-if="hasPermission('customer.create')"
            >
              Submit
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>

      <Snackbars
        :text="successMsg"
        :snackbar="snackbar"
        :color="'success'"
        @classSnackbar="closeSnackbar"
      />
      <Snackbars
        :text="'Validation error please scroll up'"
        :snackbar="snackbarError"
        :color="'red'"
        @classSnackbar="closeSnackbar"
      />
    </v-form>
    <v-dialog v-model="categoryDialog" max-width="400px">
      <v-card>
        <v-card-title>
          <span class="headline">Add New Category</span>
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="newCategory.name"
            label="Category Name"
            required
            outlined
            dense
          />
          <v-select
            v-model="newCategory.status"
            :items="['ACTIVE', 'INACTIVE']"
            label="Status"
            outlined
            dense
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="createCategory">Save</v-btn>
          <v-btn text @click="categoryDialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Alert from "@/components/shared/Alert";
import { CustomerService } from "@/services/customer-service.js";
import { checkError } from "@/config/errors.js";
import Snackbars from "@/components/shared/Snackbars";
import FileUpload from "@/components/shared/FileUpload";
import HeaderDividerBlock from "@/components/shared/HeaderDividerBlock";
import ImageBox from "@/components/shared/ImageBox";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");

export default {
  name: "CreateCustomer",
  components: { Alert, Snackbars, FileUpload, HeaderDividerBlock, ImageBox },

  data: () => ({
    role: localStorage.getItem("role") || null,
    imageUrl: "null",
    form: {
      title: "",
      first_name: "",
      last_name: "",
      company_name: "",
      vat_number: "",
      tax_number: "",
      phone: "",
      mobile: "",
      email: "",
      address1: "",
      address2: "",
      postal_code: "",
      city: "",
      country_id: "",
      state_id: "",
      logo: null,
      customer_category_id: "",
    },
    categoryDialog: false,
    newCategory: {
      name: "",
      status: "ACTIVE",
    },
    countries: [],
    states: [],
    customerCategories: [],
    snackbar: false,
    snackbarError: false,
    successMsg: "Customer has been created successfully",
    errors: null,
    loading: false,
    loading2: false,
    titleList: ["Mr", "Ms", "Miss", "Mrs", "Dr", "Prof", "Other"],
    emailRules: [
      (v) =>
        !v ||
        /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(v) ||
        "E-mail must be valid",
    ],
    phoneRules: [
      (v) =>
        !v || /^\d{10}$/.test(v) || "Phone number must be exactly 10 digits",
    ],
  }),

  computed: {
    ...mapGetters({
      profile: "profile",
      hasPermission: "hasPermission",
    }),
    customerCategoryOptions() {
      return [
        { id: "add_new", name: "➕ Add New Category" },
        ...this.customerCategories,
      ];
    },
  },

  mounted() {
    this.getCountries();
    this.getCustomerCategories();
  },

  methods: {
    onCountryChange(countryId) {
      if (countryId) {
        this.getStates(countryId);
      } else {
        this.states = [];
      }
    },
    submit() {
      this.loading = true;
      this.errors = null;
      let fd = new FormData();

      fd.append("title", this.form.title);
      fd.append("company_name", this.form.company_name);
      fd.append("vat_number", this.form.vat_number);
      fd.append("tax_number", this.form.tax_number);
      fd.append("first_name", this.form.first_name);
      fd.append("last_name", this.form.last_name);
      fd.append("email", this.form.email);
      fd.append("address1", this.form.address1);
      fd.append("address2", this.form.address2);
      fd.append("postal_code", this.form.postal_code);
      fd.append("city", this.form.city);
      fd.append("country_id", this.form.country_id);
      fd.append("state_id", this.form.state_id);
      fd.append("phone", this.form.phone);
      fd.append("mobile", this.form.mobile);
      fd.append("customer_category_id", this.form.customer_category_id);

      if (this.form.logo) {
        fd.append("logo", this.form.logo);
      }
      CustomerService.create(fd)
        .then((response) => {
          this.loading = false;
          if (response.data) {
            this.reset();
            this.snackbar = true;
            this.snackbarError = false;
            setTimeout(() => {
              this.$router.push("/customers");
            }, 1000);
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
          window.scrollTo(0, 0);
        });
    },

    async getCountries() {
      this.loading = true;
      try {
        const countries = await CustomerService.getCountries();
        this.countries = countries.data.data;
      } catch (err) {
        console.error(err);
        this.errors = err.response?.data || "Error fetching Countries.";
      }
    },
    onCategoryChange(val) {
      if (val === "add_new") {
        this.categoryDialog = true;
        this.form.customer_category_id = null;
      }
    },
    async createCategory() {
      this.loading2 = true;
      try {
        const response = await CustomerService.createCategory(this.newCategory);
        if (response.data && response.data.data) {
          this.customerCategories.unshift(response.data.data);
          this.form.customer_category_id = response.data.data.id;
          this.categoryDialog = false;
          this.newCategory = { name: "", status: "ACTIVE" };
        }
      } catch (err) {
        this.errors = err.response?.data || "Error creating category.";
      } finally {
        this.loading2 = false;
      }
    },

    async getStates(countryId) {
      this.loading = true;
      try {
        const response = await CustomerService.getStates(countryId);
        this.states = response.data;
      } catch (err) {
        console.error(err);
        this.errors = err.response?.data || "Error fetching States.";
      } finally {
        this.loading = false;
      }
    },

    async getCustomerCategories() {
      this.loading = true;
      try {
        const customerCategory = await CustomerService.getCustomerCategories();
        this.customerCategories = customerCategory.data.data;
      } catch (err) {
        console.error(err);
        this.errors =
          err.response?.data || "Error fetching Customer Categories.";
      }
    },

    changeFile(event) {
      if (event) {
        this.imageUrl = URL.createObjectURL(event);
        this.form.logo = event;
      } else {
        this.imageUrl = "null";
        this.form.logo = null;
      }
    },

    closeSnackbar() {
      this.snackbar = false;
    },

    onDismissed() {
      this.errors = null;
    },

    reset() {
      this.form = [];
    },
  },
};
</script>
